<template>
  <AgGridVue
    class="ag-theme-alpine mt-2 saleryFactor"
    style="width: 100%; height: calc(-100px + 100vh)"
    :columnDefs="columnDefs"
    :rowData="rowData"
    :defaultColDef="defaultColDef"
    :gridOptions="gridOptions"
    :getRowId="getRowId"
    rowSelection="multiple"
    :singleClickEdit="true"
    :stopEditingWhenCellsLoseFocus="true"
    :suppressHorizontalScroll="false"
    :domLayout="'normal'"
    :context="{ componentParent: this, currency: this.$store.state.currency.symbol }"
    @grid-ready="onGridReady"
    @selection-changed="onSelectionChanged"
    @row-drag-end="onRowDragEnd"
    :rowHeight="35"
    :overlayLoadingTemplate="`<span class='ag-overlay-loading-center'>${$t(
      'fetching-data'
    )}</span>`"
    :overlayNoRowsTemplate="`<span class='ag-overlay-loading-center'>${$t(
      'no-data-found'
    )}</span>`"
  />
</template>
<script>
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import DenominatorSelectEditor from "../partial/details/DenominatorSelectEditor.vue";
import BasisCalcSelectEditor from "../partial/details/BasisCalcSelectEditor.vue";
import AgMoney from "@/views/dashboard/components/general/AgGridComponents/Ag-money.vue";
import AgVMenu from "@/views/dashboard/components/general/AgGridComponents/Ag-vmenu.vue";

export default {
  name: "SalaryFactorMock",
  props: {
    saveReturn: {
      type: Boolean,
      default: false,
    },
    nameParam: {
      type: String,
      default: "",
    },
    loading: Boolean,
    callRefresh: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AgGridVue: Vue.extend(AgGridVue),
    AgMoney: Vue.extend(AgMoney),
    DenominatorSelectEditor: Vue.extend(DenominatorSelectEditor),
    BasisCalcSelectEditor: Vue.extend(BasisCalcSelectEditor),
    AgVMenu: Vue.extend(AgVMenu),
  },
  data() {
    return {
      // loading: true,
      moneyColumns: ["defaultAmount"],
      smallNumberMaxWidth: 60,
      tableOptions: {
        itemsPerPage: 1000,
      },
      factors: [],
      deletedRows: [],
      rowInstancesById: {},
      neme_parameter: "",
      gridApi: null,
      gridColumnApi: null,
      selectedRowData: null,
      selectedRowIndex: null,
      defaultColDef: {
        resizable: true,
        sortable: false,
        editable: (params) => {
          const row = params.data;
          if (!row) return true;
          if (row.type === "manual" && row.level === "deductions") return false;
          if (row.type === "manual" && row.level === "benefit") return false;
          return true;
        },
      },
      totals: { debtor: 0, creditor: 0 },
      gridOptions: {
        enableRtl: true,
        context: { componentParent: this },
        getRowClass: (params) => {
          const row = params.data;
          if (row?.type === "manual" && row?.level === "deductions") {
            return "row-disabled";
          }
          if (row?.type === "manual" && row?.level === "benefit") {
            return "row-disabled-partial";
          }
          return "";
        },
        onCellValueChanged: (params) => {
          const vm = params.context.componentParent;
          const { data: row, colDef, oldValue, newValue } = params;
          if (oldValue === newValue) return;
          vm.rowInstancesById[row.id] = vm.buildRowInstance(row, params.node.rowIndex);
          vm.$emit("table-changing", Object.values(vm.rowInstancesById));
        },
        rowSelection: "multiple",
        rowDragManaged: true,
        suppressKeyboardEvent: (params) => {
          if (params.data?.level === "deductions") {
            if (["Enter", " "].includes(params.event.key)) {
              return true;
            }
          }
          const key = params.event.key;
          const editingCells = params.api?.getEditingCells?.() || [];
          const isEditingAutoComplete = editingCells.some(
            (cell) =>
              cell.rowIndex === params.node?.rowIndex &&
              cell.column.getColId() === "given"
          );

          if (isEditingAutoComplete) {
            if (["ArrowDown", "ArrowUp", "Enter", "Escape"].includes(key)) {
              return true;
            }
          }
          const isEditingDenominatorType = editingCells.some(
            (cell) =>
              cell.rowIndex === params.node?.rowIndex &&
              cell.column.getColId() === "denominatorType"
          );
          if (isEditingDenominatorType) {
            if (["ArrowDown", "ArrowUp", "Enter", "Escape"].includes(key)) {
              return true;
            }
          }
          const isEditingBasisOfCalc = editingCells.some(
            (cell) =>
              cell.rowIndex === params.node?.rowIndex &&
              cell.column.getColId() === "basisOfCalc"
          );
          if (isEditingBasisOfCalc) {
            if (["ArrowDown", "ArrowUp", "Enter", "Escape"].includes(key)) {
              return true;
            }
          }
          return false;
        },

        suppressHorizontalScroll: true,
        rowHoverHighlight: false,
      },
      contractFactors: [
        { id: 1, field: "applicableInsurance" },
        { id: 2, field: "applicableTax" },
      ],
      effectiveWorksMock: [],
      InsuranceTaxes: [],
      Other: [
        {
          field: "fixedCoefficient",
          type: "number",
        },
        {
          field: "fixedNumber",
          type: "number",
        },
      ],
      columnDefs: [],
      rowData: [],
    };
  },
  created() {
    this.buildColumnDefs();
  },
  mounted() {
    document.addEventListener("keydown", this.globalKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.globalKeyDown);
  },
  watch: {
    rowData: {
      deep: true,
      handler(newVal) {
        this.$nextTick(() => {
          this.adjustColumnWidth("defaultAmount");
          this.effectiveWorksMock.forEach((item) => {
            this.adjustColumnWidth(item.field);
          });
        });
      },
    },
    saveReturn: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.buildSaleryFactors();
          this.$emit("again-ready-to-save");
        }
      },
    },
    callRefresh: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.fetchData();
        }
      },
    },
  },
  methods: {
    globalKeyDown(event) {
      const api = this.gridApi;
      if (!api) return;
      if (api.getEditingCells?.().length) return;
      if (!["ArrowUp", "ArrowDown"].includes(event.key)) {
        return;
      }
      event.preventDefault();
      const focused = api.getFocusedCell();
      if (!focused) {
        const firstCol = api.getAllDisplayedColumns()[0];
        if (!firstCol) return;
        api.setFocusedCell(0, firstCol.getColId());
        api.getDisplayedRowAtIndex(0)?.setSelected(true);
        return;
      }
      const direction = event.key === "ArrowDown" ? 1 : -1;
      this.navigateRow(api, direction);
    },
    navigateRow(api, direction) {
      const selectedNodes = api.getSelectedNodes();
      const totalRows = api.getDisplayedRowCount();
      let nextIndex = 0;
      let currentColumn = api.getFocusedCell()?.column?.getColId();
      if (selectedNodes.length) {
        const currentIndex = selectedNodes[0].rowIndex;
        const currentColumnIndex = api.getFocusedCell()?.column?.getColId();
        currentColumn = currentColumnIndex;
        nextIndex = currentIndex + direction;
      }
      if (nextIndex < 0) nextIndex = 0;
      if (nextIndex >= totalRows) nextIndex = totalRows - 1;
      api.forEachNode((node) => node.setSelected(false));
      const targetNode = api.getDisplayedRowAtIndex(nextIndex);
      if (targetNode) {
        targetNode.setSelected(true);
        api.ensureIndexVisible(nextIndex);
        api.setFocusedCell(nextIndex, currentColumn);
      }
    },
    setInitialFocus() {
      const api = this.gridApi;
      if (!api || api.getDisplayedRowCount() === 0) return;
      const firstCol = api.getAllDisplayedColumns()[0];
      if (!firstCol) return;
      api.setFocusedCell(0, firstCol.getColId());
      api.getDisplayedRowAtIndex(0)?.setSelected(true);
    },
    adjustColumnWidth(colId, maxWidth = 150, minWidth = 25) {
      if (!this.gridApi || !this.gridColumnApi) return;
      let maxLength = 0;
      let hasLargeValue = false;
      this.gridApi.forEachNodeAfterFilterAndSort((node) => {
        const value = node.data?.[colId];
        if (value == null) return;
        if (Math.abs(value) > 9999) {
          hasLargeValue = true;
        }
        const text = new Intl.NumberFormat().format(value);
        maxLength = Math.max(maxLength, text.length);
      });
      if (!this.moneyColumns.includes(colId) && !hasLargeValue) {
        let calculatedWidth = maxLength * 6 + 15;
        calculatedWidth = Math.min(calculatedWidth, this.smallNumberMaxWidth);
      } else {
        let calculatedWidth = maxLength * 8 + 30;
        const finalWidth = Math.min(maxWidth, Math.max(minWidth, calculatedWidth));
        this.gridColumnApi.setColumnWidth(colId, finalWidth);
      }
    },
    buildColumnDefs() {
      const dynamicColumnsContract = this.contractFactors.map((item, index) => ({
        headerName: this.$t(item.field),
        field: item.field,
        cellRenderer: "agCheckboxCellRenderer",
        cellEditor: "agCheckboxCellEditor",
        width: 35,
        maxWidth: 35,
        minWidth: 35,
        // editable: true,
        editable: (params) => params.data?.level !== "deductions",
        resizable: false,
        headerClass: ["vertical-header", "bgColor-contract"],
        cellClass: (params) => {
          if (params.data?.level === "deductions") {
            return ["checkbox-disabled", "bgColor-contract"];
          }
          return ["bgColor-contract"];
        },
        valueGetter: (params) => {
          return params.data?.[item.field] ?? false;
        },
      }));
      const dynamicColumnsInsurance = this.InsuranceTaxes.map((item, index) => {
        return {
          headerName: item.title,
          field: item.field,
          cellRenderer: "agCheckboxCellRenderer",
          cellEditor: "agCheckboxCellEditor",
          width: 35,
          maxWidth: 35,
          minWidth: 35,
          editable: true,
          resizable: false,
          headerClass: ["vertical-header", "bgColor-insurance"],
          cellClass: "bgColor-insurance",
        };
      });
      const dynamicColumnsEffectiveWorks = this.effectiveWorksMock.map((item) => ({
        headerName: item.title,
        field: item.field,
        editable: true,
        cellEditor: "agNumberCellEditor",
        valueGetter: (params) => {
          return params.data[item.field] ?? 0;
        },
        valueParser: (params) => {
          const v = Number(params.newValue);
          return isNaN(v) ? 0 : v;
        },
        onCellValueChanged: (params) => {
          const value = params.newValue ?? 0;
          params.node.setDataValue(item.field, value);
          this.adjustColumnWidth(item.field);
        },
        width: 35,
        minWidth: 35,
        resizable: false,
        headerClass: ["vertical-header"],
      }));
      dynamicColumnsEffectiveWorks.push({
        headerName: this.$t("effectiveWorksMin"),
        field: "effectiveWorksMin",
        cellRenderer: "agCheckboxCellRenderer",
        cellEditor: "agCheckboxCellEditor",
        width: 55,
        maxWidth: 55,
        minWidth: 55,
        editable: true,
        resizable: false,
        headerClass: ["horizental-header", "bgColor-effectiveWorks-related"],
        cellClass: "bgColor-effectiveWorks-related",
        valueGetter: (params) => {
          return params.data?.effectiveWorksMin ?? false;
        },
      });
      dynamicColumnsEffectiveWorks.push({
        headerName: this.$t("basisOfCalc"),
        field: "basisOfCalc",
        editable: true,
        resizable: false,
        singleClickEdit: true,
        cellRenderer: (params) => {
          const map = {
            daily: "روزانه",
            hour: "ساعتی",
          };
          const value = params.value ?? "daily";
          const label = map[value];
          return `
        <div class="denominator-select-btn basis-select-btn">
          <span class="text">${label}</span>
          <span class="icon">▾</span>
        </div>
      `;
        },
        cellEditor: "BasisCalcSelectEditor",
        valueGetter: (params) => params.data.basisOfCalc ?? "daily",
        onCellValueChanged: (params) => {
          params.node.setDataValue("basisOfCalc", params.newValue ?? "daily");
        },
        width: 85,
        minWidth: 80,
        headerClass: ["vertical-header", "bgColor-effectiveWorks-related"],
        cellClass: ["bgColor-effectiveWorks-related", "denominator-cell"],
      });
      const dynamicColumnsOthers = this.Other.map((item) => ({
        headerName: this.$t(item.field),
        field: item.field,
        editable: true,
        cellEditor: "agNumberCellEditor",
        valueGetter: (params) => {
          return params.data[item.field] ?? 0;
        },
        valueParser: (params) => {
          const v = Number(params.newValue);
          return isNaN(v) ? 0 : v;
        },
        onCellValueChanged: (params) => {
          const value = params.newValue ?? 0;
          params.node.setDataValue(item.field, value);
          this.adjustColumnWidth(item.field);
        },
        width: 35,
        minWidth: 30,
        resizable: false,
        headerClass: ["vertical-header", "bgColor-other"],
        cellClass: "bgColor-other",
      }));
      dynamicColumnsOthers.push({
        headerName: this.$t("defaultAmount"),
        field: "defaultAmount",
        editable: true,
        cellEditor: "AgMoney",
        cellEditorParams: () => ({
          currencySymbol: this.$store?.state?.currency?.symbol || "",
          precision: 0,
        }),
        valueFormatter: (params) => {
          const currency = this.$store?.state?.currency?.symbol || "";
          if (params.value == null) return `0 ${currency}`;
          return new Intl.NumberFormat().format(params.value) + " " + currency;
        },
        valueParser: (params) => {
          if (!params.newValue) return 0;
          const number = Number(params.newValue.toString().replace(/,/g, ""));
          return isNaN(number) ? 0 : number;
        },
        onCellValueChanged: (params) => {
          const value = params.newValue;
          params.node.setDataValue("defaultAmount", value);
          this.adjustColumnWidth("defaultAmount");
        },
        width: 50,
        minWidth: 50,
        resizable: false,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        headerClass: ["vertical-header", "bgColor-other", "smooth-resize"],
        cellClass: ["bgColor-other", "smooth-resize"],
      });
      dynamicColumnsOthers.push({
        headerName: this.$t("denominatorType"),
        field: "denominatorType",
        editable: true,
        singleClickEdit: true,
        cellRenderer: (params) => {
          const map = {
            fixed: "عدد ثابت",
            monthDays: "روزهای ماه",
          };
          const value = params.value ?? "monthDays";
          const label = map[value];
          return `
        <div class="denominator-select-btn">
          <span class="text">${label}</span>
          <span class="icon">▾</span>
        </div>
      `;
        },
        cellEditor: "DenominatorSelectEditor",
        valueGetter: (params) => params.data.denominatorType ?? "monthDays",
        onCellValueChanged: (params) => {
          const v = params.newValue ?? "monthDays";
          params.node.setDataValue("denominatorType", v);
          params.api.refreshCells({
            rowNodes: [params.node],
            columns: ["denominator"],
            force: true,
          });
        },
        width: 90,
        minWidth: 80,
        resizable: false,
        headerClass: ["vertical-header", "bgColor-other"],
        cellClass: ["bgColor-other", "denominator-cell"],
      });
      dynamicColumnsOthers.push({
        headerName: this.$t("denominator"),
        field: "denominator",
        cellEditor: "agNumberCellEditor",
        editable: (params) => {
          return params.data?.denominatorType === "fixed";
        },
        valueGetter: (params) => params.data?.denominator ?? 0,
        valueParser: (params) => {
          const v = Number(params.newValue);
          return isNaN(v) ? 0 : v;
        },
        onCellValueChanged: (params) => {
          const value = params.newValue ?? 0;
          params.node.setDataValue("denominator", value);
          this.adjustColumnWidth("denominator");
        },

        width: 35,
        minWidth: 35,
        resizable: false,
        headerClass: ["vertical-header", "bgColor-other"],
        cellClass: (params) => {
          if (params.data?.denominatorType !== "fixed") {
            return ["bgColor-other", "checkbox-disabled"];
          }
          return ["bgColor-other"];
        },
      });
      this.columnDefs = [
        {
          headerName: "اطلاعات عامل",
          marryChildren: true,
          resizable: false,
          children: [
            {
              headerName: this.$t("row"),
              width: 35,
              maxWidth: 35,
              minWidth: 35,
              cellRenderer: "AgVMenu",
              cellRendererParams: (params) => ({
                items: [
                  {
                    label: this.$t("delete"),
                    icon: "mdi-trash-can-outline",
                    iconColor: "gray",
                    action: (rowData) => this.deleteAction(params),
                  },
                ],
              }),
              resizable: false,
              editable: false,
              pinned: "right",
              headerClass: "vertical-header",
              cellClass: ["factor-info-pinned", "factor-row-menu"],
            },
            {
              headerName: this.$t("caption"),
              field: "name",
              width: 100,
              maxWidth: 100,
              minWidth: 100,
              resizable: false,
              editable: false,
              pinned: "right",
              headerClass: "vertical-header",
              cellClass: "factor-info-pinned",
              valueFormatter: (params) => {
                if (!params.value) return "";
                const text = this.$t(params.value);
                return text.length > 12 ? text.substring(0, 12) + "..." : text;
                // return this.$t(params.value);
              },
            },
            {
              headerName: this.$t("type"),
              field: "type",
              width: 100,
              maxWidth: 100,
              minWidth: 100,
              resizable: false,
              editable: false,
              pinned: "right",
              headerClass: "vertical-header",
              cellClass: "factor-info-pinned",
              valueFormatter: (params) => {
                if (!params.value) return "";
                return this.$t(params.value);
              },
            },
            {
              headerName: this.$t("group"),
              field: "level",
              width: 70,
              maxWidth: 70,
              minWidth: 70,
              resizable: false,
              editable: false,
              pinned: "right",
              headerClass: "vertical-header",
              cellClass: "factor-info-pinned",
              valueFormatter: (params) => {
                if (!params.value) return "";
                return this.$t(params.value);
              },
            },
          ],
        },
        {
          headerName: this.$t("insurance _and_taxes"),
          marryChildren: true,
          children: dynamicColumnsContract,
          resizable: false,
          headerClass: "headerName-contract",
        },
        {
          headerName: this.$t("contractual_factors"),
          marryChildren: true,
          resizable: false,
          children: dynamicColumnsInsurance,
          headerClass: "headerName-insurance",
        },
        {
          headerName: this.$t("effective_functions"),
          marryChildren: true,
          resizable: false,
          children: dynamicColumnsEffectiveWorks,
          headerClass: "headerName-effectiveWorks",
        },
        {
          headerName: "سایر",
          marryChildren: true,
          resizable: false,
          children: dynamicColumnsOthers,
          headerClass: "headerName-others",
        },
      ];
    },
    getRowId(params) {
      return params.data.id;
    },
    async fetchData() {
      var app = this;
      if (this.gridApi) {
        this.gridApi.showLoadingOverlay();
      }
      const id_ = app.$route.params.id ? app.$route.params.id : 0;
      app.$axios
        .get(app.$endpoint + "salary-factor-config/" + id_)
        .then((res) => {
          this.neme_parameter = res.data.name;
          let mapingChenged = res.data.configs;
          mapingChenged.forEach((row) => {
            if (row.changed == true) {
              row.changed = false;
            }
          });
          const configs = res.data.configs;
          const factors = res.data.factors;
          this.factors = Array.isArray(factors) ? factors : [];
          if (!Array.isArray(configs) || !Array.isArray(factors)) {
            this.InsuranceTaxes = [];
            this.effectiveWorksMock = [];
            return;
          }
          const factorArray = new Map(factors.map((f) => [String(f.id), f]));
          const fieldSet = new Set();
          configs.forEach((config) => {
            Object.keys(config).forEach((key) => {
              if (/^\d+$/.test(key) && factorArray.has(key)) {
                fieldSet.add(key);
              }
            });
          });
          this.InsuranceTaxes = [];
          this.effectiveWorksMock = [];
          fieldSet.forEach((field) => {
            const factor = factorArray.get(field);
            if (factor.level == "performance") {
              this.effectiveWorksMock.push({
                id: Number(field),
                title: factor.name,
                field,
                value: Number(factor.value) || 0,
              });
            } else if (factor.type == "fixed_contract") {
              this.InsuranceTaxes.push({
                id: Number(field),
                title: factor.name,
                field,
                value: Boolean(factor.value),
              });
            }
          });
          this.rowData = configs;
          this.buildColumnDefs();
          this.$nextTick(() => {
            this.gridApi?.setColumnDefs(this.columnDefs);
            this.adjustAllNumberColumns();
            this.gridApi?.hideOverlay();
          });
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          this.$emit("update-name", this.neme_parameter);
          this.$emit("call-refresh");
        });
    },
    NumberArray(data) {
      if (!Array.isArray(data) || !data.length) return [];
      const numberFields = new Set();
      data.forEach((row) => {
        Object.keys(row).forEach((key) => {
          const value = row[key];
          if (typeof value === "number" && !isNaN(value)) {
            numberFields.add(key);
          }
        });
      });
      return Array.from(numberFields);
    },
    adjustAllNumberColumns() {
      if (!this.gridApi || !this.numberColumns?.length) return;
      this.numberColumns.forEach((colId) => {
        this.adjustColumnWidth(colId);
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.fetchData();
      this.setInitialFocus();
    },
    buildRowInstance(row, rowIndex) {
      return {
        row_id: row.id,
        row_index: rowIndex,
        name: row.name,
        fixedNumber: row.fixedNumber,
        fixedCoefficient: row.fixedCoefficient,
        denominatorType: row.denominatorType,
        denominator: row.denominator,
        level: row.type,
        instanceeffectiveWorksMock: this.effectiveWorksMock
          .map((f) => ({
            factor_id: f.id,
            title: f.title,
            value: Number(row[f.field]) || 0,
          }))
          .filter((f) => f.value > 0),

        instanceInsuranceTaxes: this.InsuranceTaxes.map((f) => ({
          factor_id: f.id,
          title: f.title,
          value: Boolean(row[f.field]),
        })).filter((f) => f.value === true),
      };
    },
    onSelectionChanged() {
      const selectedNodes = this.gridApi.getSelectedNodes();
      if (!selectedNodes.length) return;
      const lastNode = selectedNodes[selectedNodes.length - 1];
      const row = lastNode.data;
      this.rowInstancesById = {};
      this.rowInstancesById[row.id] = this.buildRowInstance(row, lastNode.rowIndex);
      this.$emit("table-changing", [this.rowInstancesById[row.id]]);
    },
    onRowDragEnd() {
      const updated = [];
      this.gridApi.forEachNode((node) => updated.push(node.data));
      this.rowData = updated;
    },
    deleteAction(params) {
      const rowData = params.data;
      const rowIndex = params.node.rowIndex;
      this.gridApi.applyTransaction({
        remove: [rowData],
      });
      this.rowData = this.rowData.filter((row) => row.id !== rowData.id);
    },
    buildSaleryFactors() {
      var app = this;
      let data = app.rowData;
      let Name = app.nameParam;
      if (Name == null) {
        app.$emit("validation", false);
        return;
      }
      const invalidRows = this.rowData.filter((row) =>
        this.InsuranceTaxes.every((cf) => row[cf.field] !== true)
      );
      if (invalidRows.length == app.rowData.length) {
        this.$emit("at-least-one-required");
        this.$emit("again-ready-to-save");
        return;
      }
      const id_ = app.$route.params.id ? app.$route.params.id : 0;
      if (id_ > 0) {
        app.$axios
          .put(this.$endpoint + "salary-factor-config/" + id_, {
            configs: data,
            name: Name,
          })
          .then((response) => {})
          .catch((err) => {
            app.$emit("again-ready-to-save");
            app.serverErrorHandeler(err);
          })
          .finally(() => {
            app.$emit("again-ready-to-save");
            this.$router.push("/payroll/salery_factors");
          });
      } else {
        app.$axios
          .post(this.$endpoint + "salary-factor-config", {
            configs: data,
            name: Name,
          })
          .then((response) => {})
          .catch((err) => {
            app.$emit("again-ready-to-save");
            app.serverErrorHandeler(err);
          })
          .finally(() => {
            app.$emit("again-ready-to-save");
            this.$router.push("/payroll/salery_factors");
          });
      }
    },
  },
};
</script>
<style>
.ag-theme-alpine.saleryFactor .ag-header-row.ag-header-row-column {
  height: 100% !important;
}
.ag-theme-alpine.saleryFactor .ag-header-row.ag-header-row-column .ag-header-cell {
  height: 100px !important;
  min-height: 95px !important;
}
.ag-theme-alpine.saleryFactor .ag-header {
  height: auto !important;
  min-height: 135px !important;
}
.vertical-header .ag-header-cell-label {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  justify-content: center;
  align-items: center;
  height: 90px;
  padding: 0px;
  white-space: nowrap;
}
.ag-theme-alpine.saleryFactor .ag-header-row.ag-header-row-column-group {
  height: 35px !important;
}
.ag-theme-alpine.saleryFactor .ag-header-row.ag-header-row-column {
  top: 35px !important;
}
.horizental-header .ag-cell-label-container {
  display: block !important;
  overflow: visible !important;
}
.horizental-header .ag-header-cell-label {
  overflow: visible;
  text-overflow: unset;
  display: block;
}
.horizental-header .ag-header-cell-text {
  overflow: visible;
  text-overflow: unset;
  display: block;
  white-space: normal !important;
  text-align: center;
}
@media (max-width: 768px) {
  table.visual td {
    width: 100%;
    display: block;
    box-sizing: border-box;
  }
  table.visual {
    width: 100%;
    table-layout: auto;
  }
}
@media (max-width: 480px) {
  table.visual .column-width {
    width: 100%;
  }
  table.visual .column-width-small {
    width: 100%;
  }
}
.ag-theme-alpine.saleryFactor .ag-body-horizontal-scroll {
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
}
.ag-theme-alpine.saleryFactor .ag-body-horizontal-scroll ::-webkit-scrollbar {
  height: 8px;
}
.ag-theme-alpine.saleryFactor .ag-body-horizontal-scroll ::-webkit-scrollbar-track {
  background: #f1f0f0;
  border-radius: 6px;
}
.ag-theme-alpine.saleryFactor .ag-body-horizontal-scroll ::-webkit-scrollbar-thumb {
  background: #bdbdbdd2;
  border-radius: 6px;
}
.ag-theme-alpine.saleryFactor .ag-body-horizontal-scroll ::-webkit-scrollbar-thumb:hover {
  background: #9e9e9ecf;
}
.v-data-table__wrapper {
  min-height: 0;
  height: 100%;
}
.invalid-cell {
  background-color: rgba(255, 102, 102, 0.4) !important;
  transition: background-color 0.3s ease;
}
.ag-input-field-input.ag-checkbox-input {
  cursor: pointer;
}
.ag-theme-alpine.saleryFactor .ag-header-cell,
.ag-theme-alpine.saleryFactor .ag-header-group-cell {
  padding: 0px;
  border-left: 1px solid #cfcfcf;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ag-theme-alpine.saleryFactor .ag-header-group-text {
  font-weight: bold;
  font-size: 12px;
  padding: 2px 0;
}

.ag-theme-alpine.saleryFactor.ag-rtl .ag-cell-wrapper {
  flex-direction: row-reverse;
}
.ag-wrapper.ag-input-wrapper.ag-checkbox-input-wrapper.ag-checked {
  background-color: transparent;
}
.ag-theme-alpine.saleryFactor .ag-checkbox-input-wrapper {
  font-size: 13px !important;
}
.ag-pinned-right-header
  .ag-header-row.ag-header-row-column
  .ag-header-cell.ag-focus-managed:nth-child(1),
.ag-pinned-right-header
  .ag-header-row.ag-header-row-column
  .ag-header-cell.ag-focus-managed:nth-child(3) {
  overflow: visible;
}
.ag-theme-alpine.saleryFactor
  .ag-pinned-right-cols-container
  .ag-row
  .ag-cell:nth-child(2) {
  text-align: center;
}
.ag-theme-alpine.saleryFactor
  .ag-pinned-right-header
  .ag-header-row.ag-header-row-column
  .ag-header-cell:nth-child(1) {
  border-right: none;
}
.ag-theme-alpine.saleryFactor .ag-row {
  border-bottom: 1px solid #d3d3d3;
}
.ag-theme-alpine.saleryFactor .ag-cell {
  border-left: 1px solid #d3d3d3;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  padding: 0px !important;
}
.ag-theme-alpine.saleryFactor .ag-cell-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0px !important;
}
.ag-theme-alpine.saleryFactor .ag-cell-wrapper.ag-cell-edit-wrapper.ag-checkbox-edit {
  padding: 0px !important;
}
.ag-theme-alpine.saleryFactor .ag-cell-inline-editing {
  height: 33px !important;
}
/* .ag-theme-alpine.saleryFactor .ag-checkbox.ag-disabled {
  display: none !important;
} */
.ag-theme-alpine.saleryFactor .ag-header-cell {
  border-left: 1px solid #cfcfcf;
}
.ag-theme-alpine.saleryFactor .ag-cell.ag-column-first {
  border-right: none;
  padding: 0;
}
.ag-theme-alpine.saleryFactor .ag-rtl .ag-header-select-all,
.ag-theme-alpine.saleryFactor .ag-rtl .ag-selection-checkbox {
  margin-left: 0;
}
.ag-theme-alpine.saleryFactor .ag-rtl .ag-row-drag {
  margin-left: 2px;
}
.ag-header-cell.ag-column-first .ag-header-cell-comp-wrapper {
  width: auto !important;
}
.ag-theme-alpine.saleryFactor
  .ag-pinned-right-header
  .ag-header-row.ag-header-row-column
  .ag-header-cell:nth-child(2)
  .ag-header-cell-label {
  justify-content: center;
}
.ag-theme-alpine.saleryFactor .ag-checkbox-input-wrapper {
  width: 12px;
  height: 12px;
  margin-bottom: 5px !important;
}
.ag-theme-alpine.saleryFactor .ag-checkbox-input-wrapper:focus-within {
  box-shadow: none;
}
.ag-theme-alpine.saleryFactor .ag-row-selected,
.ag-row-selected::before {
  background-color: rgb(169 217 255 / 12%);
}
.ag-theme-alpine .ag-row-hover,
.ag-theme-alpine .ag-row-hover::after,
.ag-theme-alpine .ag-row-hover::before {
  background-color: rgb(169 217 255 / 12%) !important;
}
.ag-row-hover.ag-row-selected::before {
  background-image: none !important;
}
.ag-theme-alpine.saleryFactor .ag-cell-value.ag-cell.ag-cell-data-changed {
  background-color: rgb(255 102 102 / 41%) !important;
}
.bgColor-insurance {
  background-color: #f2f9ff !important;
}
.headerName-insurance {
  background-color: #f2f9ff !important;
}
.bgColor-contract {
  background-color: #fff4dc !important;
}
.headerName-contract {
  background-color: #fff4dc !important;
}
.bgColor-other {
  background-color: #efe3fb !important;
}
.headerName-others {
  background-color: #efe3fb !important;
}
.bgColor-effectiveWorks {
  background-color: #fcfff0 !important;
}
.bgColor-effectiveWorks-related {
  background-color: #fcfff0 !important;
}
/* hover */
.ag-row-hover .bgColor-insurance {
  background-color: #e3f2ff !important;
}
.ag-row-hover .bgColor-contract {
  background-color: #ffe9b3 !important;
}
.ag-row-hover .bgColor-other {
  background-color: #e6d6fa !important;
}
.ag-row-hover .bgColor-effectiveWorks,
.ag-row-hover .bgColor-effectiveWorks-related {
  background-color: #f3f7dc !important;
}
/* selected */
.ag-row-selected .bgColor-insurance {
  background-color: #e3f2ff !important;
}

.ag-row-selected .bgColor-contract {
  background-color: #ffe9b3 !important;
}

.ag-row-selected .bgColor-other {
  background-color: #e6d6fa !important;
}

.ag-row-selected .bgColor-effectiveWorks,
.ag-row-selected .bgColor-effectiveWorks-related {
  background-color: #f3f7dc !important;
}
.denominator-cell {
  padding: 4px !important;
}

.denominator-select-btn {
  height: 22px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  cursor: pointer;
  font-size: 12px;
}
.denominator-select-btn {
  width: 80px;
}
.basis-select-btn {
  width: 73px;
}

.denominator-select-btn .text {
  color: #444;
  white-space: nowrap;
}

.denominator-select-btn .icon {
  font-size: 18px;
  color: #666;
}

.ag-row-hover .denominator-select-btn {
  border-color: #b5b5b5;
}
/* manual + کسورات: بقیه غیرفعال؛ فقط AgVMenu (factor-row-menu) برای حذف فعال */
.row-disabled {
  background: #f5f5f5 !important;
}
.row-disabled .ag-cell:not(.factor-row-menu) {
  opacity: 0.5;
  pointer-events: none;
}
.row-disabled .ag-cell.factor-row-menu {
  opacity: 1;
  pointer-events: auto;
}
/* manual + مزایا: غیرفعال به‌جز ستون‌های قرارداد (بدون pointer-events:none روی ردیف) */
.row-disabled-partial {
  background: #f5f5f5 !important;
}
.row-disabled-partial .ag-cell:not(.bgColor-contract):not(.factor-info-pinned) {
  opacity: 0.55;
  pointer-events: none;
}
.row-disabled-partial .ag-cell.bgColor-contract,
.row-disabled-partial .ag-cell.factor-info-pinned {
  opacity: 1;
}
.checkbox-disabled {
  pointer-events: none;
  opacity: 0.6;
}
</style>
